import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron_down",
  "use": "chevron_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron_down\"><path d=\"M7.406 7.828L12 12.422l4.594-4.594L18 9.234l-6 6-6-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol